import BaseView from '../../../views/base';
import CompleteListTemplate from '../templates/completeList.html';

const CompleteListView = BaseView.extend({
    events: {
        'click .js-complete-list-link': 'toggleCompleteList',
        'click .js-toggle-children': 'toggleChildren',
        'keydown .js-toggle-children': 'toggleChildren',
    },

    initialize({ target, model, collection }) {
        this.target = target;
        this.model = model;
        this.libraries = collection;
        this.listenTo(this.libraries, 'sync', this.maybeRender);
        this.template = CompleteListTemplate;
    },

    toggleChildren(evt) {
        const target = $(evt.target).attr('data-action')
            ? $(evt.target)
            : $(evt.target).closest('[data-branchid]');
        const branchId = target.data('branchid');
        const $children = $(`.js-children-container.js-${branchId}`);
        const $arrow = $(`.js-arrow.js-branch-${branchId}`);
        const $toggleLink = target;

        const expandKeyPressed = evt.key === 'Enter' || evt.key === ' ';
        if (
            $children.children('.js-child-branches').children().length &&
            (evt.type === 'click' || expandKeyPressed)
        ) {
            evt.preventDefault();
            evt.stopPropagation();
            $arrow.removeClass('icon-forward-arrow icon-down-arrow');

            if ($children.is(':visible')) {
                $children.hide();
                $arrow.addClass('icon-forward-arrow');
                $toggleLink.attr('aria-expanded', false);
            } else {
                $children.show().focus();
                $arrow.addClass('icon-down-arrow');
                $toggleLink.attr('aria-expanded', true);
            }
        }
    },

    afterRender() {
        this.$('.js-support-button')
            .filter((index, target) => !$(target).attr('href'))
            .addClass('hideMe');
    },

    maybeRender() {
        if (this.libraries.models.length) {
            this.render();
        }
    },

    getTemplateData() {
        return {
            members: this.libraries.models,
        };
    },

    onClose() {
        this.undelegateEvents();
        this.target.removeData().unbind();
        this.target.empty();
    },
});

export default CompleteListView;
